import { C } from "../lib/theme";
import { Icon } from "./Icon";

export function EmptyState({ icon = "inbox", title, body, action }) {
  return (
    <div
      style={{
        padding: "48px 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        color: C.muted,
      }}
    >
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: 16,
          background: C.cream,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 14,
        }}
      >
        <Icon name={icon} size={22} color={C.muted} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 800, color: C.charcoal, marginBottom: 4 }}>{title}</div>
      {body && <div style={{ fontSize: 12.5, maxWidth: 340, lineHeight: 1.5 }}>{body}</div>}
      {action && <div style={{ marginTop: 14 }}>{action}</div>}
    </div>
  );
}
